import { render } from "@testing-library/react";
import React, { Component } from "react";
import BannerPhoto from "../postertypes/BannerPhoto";
import NotificationPhoto from "../postertypes/NotificationPhoto";
import WatsappPhoto from "../postertypes/WatsappPhoto";

class PosterDisplay extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { data, posterType } = this.props.location.state;

    return (
      <>
        <div>
          {posterType == "watsapp" ? (
            <WatsappPhoto props={data} />
          ) : posterType == "notification" ? (
            <NotificationPhoto props={data} />
          ) : posterType == "banner" ? (
            <BannerPhoto props={data} />
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}

export default PosterDisplay;
